import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { lazy } from 'react';
import SchedulerTable from './components/SchedulerTable';

const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const SchedulerPage = ({ theme, filters, ...props }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <SchedulerTable {...props} />
    </Box>
  );
};

SchedulerPage.propTypes = {
  theme: PropTypes.object.isRequired,
  filters: PropTypes.array.isRequired,
};

export default SchedulerPage;
